import { get } from 'lodash';

import { useEntityCount } from 'requests/resources/makeResources/queries';

export function useAllUsersFilterCountQuery(enabled: boolean, stringParams?: string) {
  const totalCountQuery = useEntityCount('users/all-active-and-invited', stringParams || '', enabled);

  return [get(totalCountQuery, 'data.count', 0), totalCountQuery.isLoading];
}
